export default "/images/vendor/flag-icons/flags/4x3/eh.svg?55c167e4b4a7c19c3afd44599d77d3ba";